import React, {
	useCallback, useEffect, useState, useMemo
} from 'react'
import {
	Button, Modal, Form, Input, Switch
} from 'antd'
import {
	useDispatch, useSelector
} from 'react-redux'
import moment from 'moment'
import ReAnswerFormsSelect from '../../../nsi/ReAnswerForms/select'
import UploadFile from '../../../UploadFile'
import ModalTemplateMessages from '../../../MessageTemplates/ModalTemplateMessages'
import CustomButton from '../../../../components/ButtonCustom'
import NRISelect from "../../../nsi/NSISelector/NRISelect"
import notice from '../../../../components/Notice'
import {
	appealsActions
} from '../../store/actions'
import {
	uploadFileAction
} from '../../../UploadFile/actions'
import i18n from '../../localization'
import i18nGlobal from '../../../../localization'
import 'antd/lib/modal/style/index.css'
import 'antd/lib/switch/style/index.css'
import './style.css'
import Notifications from '../../../../helpers/Notifications'
import sign from '../../../../helpers/sign'
import AppealFilesFromAisMvModal from '../../../OrgManagement/AisMvManage/AisMvModals/AppealFilesFromAisMvModal'
import {
	default as uploadFileLocale
} from '../../../UploadFile/localization'
import controlCompleteStatusActions from '../../../nsi/ControlCompleteStatuses/actions'
import { useDebounce }from "use-lodash-debounce"

const {
	TextArea
} = Input

const isDev = process.env.NODE_ENV === 'development'

const FinaliseAppeal = ({
	id, disabled, executionResult, endSignerInfo, endSignDate, underControl = false
}) => {
	const isRu = useSelector((state) => state.globalReducer.isRu)
	const { reOrgAppeal,
		finaliseResult,
		finaliseAppealLoading } = useSelector((state) => state.appealsReducer)
	const { systemEnvironment } = useSelector((state) => state.userReducer)
	const {messages} = useSelector((state) => state.appealsControlReducer);

	const dispatch = useDispatch()

	const [isCorrespondenceTerminated, setIsCorrespondenceTerminated] = useState(false)
	const [visible, setVisible] = useState(false)
	const [filesFromAisMvModalVisible, setFilesFromAisMvModalVisible] = useState(false)
	const [visibleTemplate, setVisibleTemplate] = useState(false)

	const [file, setFile] = useState(null)
	const [fileSignatureList, setFileSignatureList] = useState([])
	const [filesFromAisMvIds, setFilesFromAisMvIds] = useState([])
	const [reportFileList, setReportFileList] = useState([])
	const [reportFileSignatureList, setReportFileSignatureList] = useState([])
	const [form] = Form.useForm()

	const maxNumberOfFiles = 5
	const [notify, setNotify] = useState("")
	const fileNotification = useDebounce(notify, 500)

	const finaliseAppeal = useCallback((params) => {
		const formData = new FormData()
		const existInSystemFiles = params.file?.filter(file => file.id)
		const filesToUpload = params.file?.filter(file => !file.id)
		const reportFilesToUpload = params.reportFileList?.filter(file => !file.id)
		if (params.fileSignatureList?.length > 0)
			params.fileSignatureList.forEach((sign) => formData.append("FileSignatures", sign))
		filesToUpload?.forEach((fileCont) => formData.append("Files", fileCont.originFileObj))
		if (params.reportFileSignatureList?.length > 0)
			params.reportFileSignatureList.forEach((sign) => formData.append("ReportFileSignatures", sign))
		reportFilesToUpload?.forEach(file => formData.append('reportFiles', file.originFileObj))
		if (params.reportText)
			formData.append("ReportText", params.reportText)
		if (params.reportSignature)
			formData.append("ReportSignature", params.reportSignature)
		if (params.signature)
			formData.append("Signature", params.signature)
		if (params.signerInfo)
			formData.append("SignerInfo", params.signerInfo)
		if (params.reAnswerForms?.length > 0)
			params.reAnswerForms.forEach((answerForm) => formData.append("ReAnswerForms", answerForm))
		if (params.isCorrespondenceTerminated !== null && params.isCorrespondenceTerminated !== undefined)
			formData.append("IsCorrespondenceTerminated", params.isCorrespondenceTerminated)
		if (existInSystemFiles?.length > 0)
			existInSystemFiles.map(file => file.id).forEach(fileId => formData.append("AnswerFilesIds", fileId))
		formData.append("ReviewResult", params.reviewResult)
		formData.append("AnswerRegNumber", params.answerRegNumber)
		formData.append("Id", params.id)
		formData.append("CaseNumber", params.caseNumber)
		formData.append("CompleteStatusId", params.completeStatusId)
		dispatch(appealsActions.finaliseAppeal(formData))
		clearState()
	}, [dispatch])

	const getReOrgAppealById = useCallback((params) => {
		dispatch(appealsActions.GetRAById(params))
	}, [dispatch])

	useEffect(() => {
		dispatch(uploadFileAction.clearFiels())
		dispatch(appealsActions.ClearResult())

		return () => {
			dispatch(appealsActions.ClearUploadFielIds())
			dispatch(uploadFileAction.clearFiels())
		}
	}, [])

	useEffect(() => {
		if (finaliseResult === true) {
			form.resetFields()
			setVisible(false)
			dispatch(appealsActions.ClearResult())
			Notifications.successNotice(
				reOrgAppeal?.controlReOrgs?.length || underControl == true 
				? (messages?.length > 0 
				   ? i18n.reportForControlOrgSuccessCreate[isRu] 
				   : i18n.appealGetStatusOnControl[isRu]) 
				: i18n.successFinalise[isRu]
			)
		}
		if (finaliseResult === false) {
			Notifications.errorNotice(i18n.changesWereNotRecordedInTheDatabase[isRu])
		}
	}, [finaliseResult])

	useEffect(() => {
		if (id !== 0) {
			getReOrgAppealById({
				id
			})
		}
	}, [id])

		//#region MessageHandle
		useEffect(() => {
			if (fileNotification){
				Notifications.errorNotice(fileNotification, '', 10)
				setNotify("")
			}
		}, [fileNotification])
		//#endregion

	const handleChangeFile = (val) => {
		setFile(val.fileList.slice(0, maxNumberOfFiles))
		setFileSignatureList([])
		if(val.fileList.length > maxNumberOfFiles){
			setNotify(uploadFileLocale.maxCountOfAdditionalFiles[isRu].format(maxNumberOfFiles))
		}
	}

	const handleRemoveFiles = (id) => {
		const newList = file.filter((item) => item.uid != id.FileId && item.id != id.FileId)
		setFile(newList)
		setFileSignatureList([])
	}

	const handleChangeReportFile = (val) => {
		if (val.fileList.length < 6) {
			setReportFileList(val.fileList)
			setReportFileSignatureList([])
		}
		else
			Notifications.errorNotice(uploadFileLocale.maxCountFiles[isRu])
	}

	const handleRemoveReportFiles = (id) => {
		const newList = reportFileList.filter((item) => item.uid != id.FileId && item.id != id.FileId)
		setReportFileList(newList)
		setReportFileSignatureList([])
	}
	
	const reportReader = useMemo(() => {
		const fileReader = new FileReader()
		fileReader.onerror = error => Notifications.errorNotice(error)
		return fileReader
	}, [])

	reportReader.onload = (evt) => {
		const base64 = evt.target.result.toString().replace(/^data:(.*,)?/, '')
		sign(base64, true, systemEnvironment.cp_address_n).then(result => {
			if (result.res) {
				setReportFileSignatureList([...reportFileSignatureList, result.res.data.cms])
			}
			else if (result.error)
				setReportFileSignatureList([])
		})
	}

	const reader = useMemo(() => {
		const fileReader = new FileReader()
		fileReader.onerror = error => Notifications.errorNotice(error)
		return fileReader
	}, [])

	reader.onload = (evt) => {
		const base64 = evt.target.result.toString().replace(/^data:(.*,)?/, '')
		sign(base64, true, systemEnvironment.cp_address_n).then(result => {
			if (result.res) {
				setFileSignatureList([...fileSignatureList, result.res.data.cms])
			}
			else if (result.error)
				setFileSignatureList([])
		})
	}

	const showModal = () => {
		setVisible(true)
	}

	const handleOk = (e) => {
		setVisible(false)
	}

	const handleCancel = (e) => {
		form.resetFields()
		setVisible(false)
	}

	useEffect(() => {
		const filesToUpload = getUnloadedFilesFromList()

		if (filesToUpload && fileSignatureList.length > 0 && fileSignatureList.length == filesToUpload?.length) {
			const values = form.getFieldsValue()
			const {
				reviewResult,
				ReAnswerForm,
				caseNumber,
				answerRegNumber,
				reportText,
				completeStatusId
			} = values
			signAndFinalise({
				answerRegNumber,
				caseNumber,
				id: id != 0 ? id : reOrgAppeal.id,
				isCorrespondenceTerminated,
				reAnswerForms: ReAnswerForm,
				reviewResult,
				reportText,
				completeStatusId
			})
		}

		else if (filesToUpload && fileSignatureList.length > 0 && fileSignatureList.length < filesToUpload?.length) {
			reader.readAsDataURL(filesToUpload[fileSignatureList.length].originFileObj)
		}
	}, [fileSignatureList])

	useEffect(() => {
		const reportFilesToUpload = getUnloadedReportFilesFromList()
		if (reportFilesToUpload.length && reportFileSignatureList.length > 0 && reportFileSignatureList.length == reportFilesToUpload?.length) {
			const filesToUpload = getUnloadedFilesFromList()
			if (filesToUpload?.length > 0 && systemEnvironment.ecpEnabled)
				reader.readAsDataURL(filesToUpload[0].originFileObj)
			else {
				const values = form.getFieldsValue()
				const {
					reviewResult,
					ReAnswerForm,
					caseNumber,
					answerRegNumber,
					reportText,
					completeStatusId
				} = values
	
				signAndFinalise({
					answerRegNumber,
					caseNumber,
					id: id != 0 ? id : reOrgAppeal.id,
					isCorrespondenceTerminated,
					reAnswerForms: ReAnswerForm,
					reviewResult,
					reportText,
					completeStatusId
				})
			}
		} else if (reportFilesToUpload.length && reportFileSignatureList.length > 0 && reportFileSignatureList.length < reportFilesToUpload?.length) {
			reportReader.readAsDataURL(reportFilesToUpload[reportFileSignatureList.length].originFileObj)
		}
	}, [reportFileSignatureList])

	const signAndFinalise = async (data) => {
		let reportSignature;
		if (systemEnvironment.ecpEnabled) {
			if(data.reportText?.trim())
				await sign(window.btoa(unescape(encodeURIComponent(data.reportText))), false, systemEnvironment.cp_address_n).then(result => {
					reportSignature = result.res ? result.res.data.cms : null
				})
		}
		if (systemEnvironment?.cp_address_n && systemEnvironment.ecpEnabled && !executionResult) {
			const b64 = window.btoa(unescape(encodeURIComponent(data.reviewResult)))
			sign(b64, false, systemEnvironment.cp_address_n).then(result => {
				if (result.res) {
					finaliseAppeal({
						...data,
						fileSignatureList: fileSignatureList.length > 0 ? fileSignatureList : null,
						file: file?.length > 0 ? file : null,
						signature: result.res.data.cms,
						signerInfo: "",
						reportFileList: reportFileList?.length > 0 ? reportFileList : null,
						reportFileSignatureList: reportFileSignatureList.length > 0 ? reportFileSignatureList : null,
						reportSignature: reportSignature,
					})
				}
				else if (result.error)
					setFileSignatureList([])
			})
		}
		else {
			finaliseAppeal({
				...data,
				fileSignatureList: fileSignatureList.length > 0 ? fileSignatureList : null,
				file: file?.length > 0 ? file : null,
				reportFileList: reportFileList?.length > 0 ? reportFileList : null,
				reportFileSignatureList: reportFileSignatureList.length > 0 ? reportFileSignatureList : null,
			})
		}
	}

	const onFinish = (values) => {
		try {
			const filesToUpload = getUnloadedFilesFromList()
			const reportFilesToUpload = getUnloadedReportFilesFromList()
			if (reportFilesToUpload?.length > 0 && systemEnvironment.ecpEnabled){
				reportReader.readAsDataURL(reportFilesToUpload[0].originFileObj)
			}
			else if (filesToUpload?.length > 0 && systemEnvironment.ecpEnabled)
				reader.readAsDataURL(filesToUpload[0].originFileObj)
			else {
				const {
					reviewResult,
					ReAnswerForm,
					caseNumber,
					answerRegNumber,
					reportText,
					completeStatusId,
				} = values
	
				signAndFinalise({
					answerRegNumber,
					caseNumber,
					id: id != 0 ? id : reOrgAppeal.id,
					isCorrespondenceTerminated,
					reAnswerForms: ReAnswerForm,
					reviewResult,
					reportText,
					completeStatusId
				})
			}
		}
		catch (e) {
			notice('error', 'Не удалось завершить исполнение обращения.', e.message, 5)
		}
	}

	const getText = (text) => {
		form.setFieldsValue({
			reviewResult: text
		})
		setVisibleTemplate(false)
	}

	//отсеиваем незагруженные файлы для подписи и загрузки 
	const getUnloadedFilesFromList = () => file?.filter(file => !file.id)
	const getUnloadedReportFilesFromList = () => reportFileList?.filter(file => !file.id)
	const clearState = () => {
		setFileSignatureList([])
	}	
	return (
		<>
			<CustomButton
				disabled={disabled}
				type="turquoise"
				onClick={showModal}
			>
				{i18n.finaliseAppeal[isRu]}
			</CustomButton>
			<Modal
				destroyOnClose
				footer={null}
				title={i18n.finaliseAppeal[isRu]}
				visible={visible}
				width={840}
				onCancel={handleCancel}
				onOk={handleOk}
			>
				<Form
					form={form}
					labelAlign="left"
					labelCol={{
						span: 8
					}}
					layout="horizontal"
					name="finaliseAppealForm"
					wrapperCol={{
						span: 16
					}}
					onFinish={onFinish}
				>
					<Form.Item
						initialValue={reOrgAppeal?.appeal?.regNumber}
						label={i18n.AnswerRegNumber[isRu]}
						name="answerRegNumber"
						rules={[
							{
								required: true,
								whitespace: true,
								message: i18n.AnswerRegNumberRequierd[isRu]
							}
						]}
					>
						<Input
							autoComplete="off"
							maxLength={200}
							placeholder={i18n.AnswerRegNumberPlaceholder[isRu]}
						/>
					</Form.Item>
					<ModalTemplateMessages
						getText={getText}
						isRu={isRu}
						setVisibleTemplate={setVisibleTemplate}
						visibleTemplate={visibleTemplate}
					/>
					<Form.Item
						extra={
							endSignerInfo && endSignDate ? (
								<span
									style={{
										marginTop: "10px",
										display: "block"
									}}
								>
									{`Подписал ${endSignerInfo}.\n  
							   ${moment(endSignDate).format("DD.MM.YYYY")}`}
								</span>) : null
						}
						initialValue={executionResult}
						label={
							(<>
								{i18n.ReviewResult[isRu]}
								<Button
									className="selectTemplateBtn"
									type="primary"
									onClick={() => setVisibleTemplate(true)}
								>
									{isRu ? 'Выбрать шаблон' : 'Выбраць шаблон'}
								</Button>
							</>)
						}
						name="reviewResult"
						rules={[
							{
								required: true,
								whitespace: true,
								message: i18n.ReviewResultRequierd[isRu]
							}
						]}
					>
						<TextArea
							autoSize={{
								minRows: 3,
								maxRows: 8
							}}
							maxLength={20000}
							placeholder={i18n.ReviewResultPlaceholder[isRu]}
						/>
					</Form.Item>
					<Form.Item
						label={i18n.appealDecision[isRu]}
						name="completeStatusId"
						rules={[{required: true}]}
					>
						<NRISelect
							actions={ controlCompleteStatusActions }
							actionType="getControlCompleteStatusesList"
							reducer="controlCompleteStatusReducer"
							itemsName="controlCompleteStatusList"
							placeholder={i18n.appealDecisionPlaceholder[isRu]}
							value={ form.getFieldValue("completeStatusId") }
							onChange={ (val) => {
								form.setFieldsValue({ completeStatusId: val?.id })
							} }
						/>
					</Form.Item>
					<ReAnswerFormsSelect
						required
						form={form}
					/>
					<Form.Item
						label={i18n.CaseNumber[isRu]}
						name="caseNumber"
						rules={[
							{
								required: true,
								whitespace: true,
								message: i18n.CaseNumberRequierd[isRu]
							}
						]}
					>
						<Input
							autoComplete="off"
							maxLength={200}
							placeholder={i18n.CaseNumberPlaceholder[isRu]}
						/>
					</Form.Item>
					<Form.Item
						label={i18n.correspondenceTerminated[isRu]}
						name="isCorrespondenceTerminated"
					>
						<Switch
							checked={isCorrespondenceTerminated}
							checkedChildren={i18nGlobal.yes[isRu]}
							unCheckedChildren={i18nGlobal.no[isRu]}
							onChange={(checked) => setIsCorrespondenceTerminated(checked)}
						/>
					</Form.Item>
					<div className="finish-form-buttons">
						<div>
							<AppealFilesFromAisMvModal
								fileIdsList={filesFromAisMvIds}
								reOrgAppealId={reOrgAppeal?.id}
								setFileIdsList={setFilesFromAisMvIds}
								setUploadFileList={setFile}
								setVisible={setFilesFromAisMvModalVisible}
								uploadFileList={file}
								visible={filesFromAisMvModalVisible}
							/>
							<UploadFile
								fileList={file}
								listType="text"
								removeFiles={handleRemoveFiles}
								onChangeCustom={handleChangeFile}
							/>
						</div>
					</div>
					{reOrgAppeal?.controlReOrgs?.length || underControl == true ? <>
						<div className="form__divider"></div>
						<Form.Item
							name="reportText"
							label={<div className="label-reason-form">
								{i18n.reportForOrganization[isRu]}
							</div>
							}
							rules={[
								{
									required: true,
									whitespace: true,
									message: i18n.reportTextForOrganizationMessage[isRu]
								}
							]}
						>
							<TextArea
								autoSize={{
									minRows: 3,
									maxRows: 8
								}}
								maxLength={5000}
							/>
						</Form.Item>
						 <Form.Item
							name="filesForOrganization"
							label={<div className="label-reason-form-upload">
								{i18n.filesForOrganization[isRu]}
							</div>
							}
						>
							<UploadFile
								fileList={reportFileList}
								listType="text"
								onChangeCustom={handleChangeReportFile}
								removeFiles={handleRemoveReportFiles}
							/>
						</Form.Item>
					</>
						: null}
					<div className="finish-form-buttons">
						<CustomButton
							htmlType="submit"
							loading={finaliseAppealLoading}
							style={{
								minWidth: '226px',
								height: '44px'
							}}
							type="orange"
						>
							{i18nGlobal.confirm[isRu]}
						</CustomButton>
					</div>
				</Form>
			</Modal>
		</>
	)
}
export default FinaliseAppeal
